import { render, staticRenderFns } from "./auto-message-review-dialog.vue?vue&type=template&id=7ffd2a26&scoped=true&"
import script from "./auto-message-review-dialog.vue?vue&type=script&lang=js&"
export * from "./auto-message-review-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffd2a26",
  null
  
)

export default component.exports